module.exports = __webpack_public_path__ + "img/people.f77775c1.svg";